import { ShareClientId } from 'src/app/services/data/companies.service';
import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {
  OptionFormDtoUpperCase,
} from 'src/app/models/dialog-dto/option-form.dto';
import { DataService } from 'src/app/services/data.service';
import { OptionTypeUpper } from 'src/app/models/option-type';
import { OptionVersion } from 'src/app/models/option-version';

interface OptionViewRow extends OptionFormDtoUpperCase {
  optIcon: string;
  optProductID: string;
  optName: string;
  optDescription: string;
  optUnit: string;
}

@Component({
  selector: 'app-mat-table-options',
  templateUrl: './mat-table-options.component.html',
  styleUrls: ['./mat-table-options.component.scss'],
})
export class MatTableOptionsComponent implements OnInit, AfterViewInit {
  @Input() verify!: boolean;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<OptionViewRow>;

  displayedColumns = ['OptionTypeID', 'Name', 'Einheit', 'Value', 'StartDate', 'EndDate'];

  tableDataSource = new MatTableDataSource<OptionViewRow>([]);

  private dataTypes: OptionTypeUpper[] = [];
  private dataVersions: OptionVersion[] = [];
  private rawDataSource: OptionFormDtoUpperCase[] = [];

  constructor(
    private shareClientId: ShareClientId,
    public dataService: DataService
  ) {}

  ngAfterViewInit(): void {
    this.tableDataSource.sort = this.sort;
    this.tableDataSource.sortingDataAccessor = (row, col) => {
      switch (col) {
        case 'OptionTypeID': return row.optProductID;
        case 'Name': return row.optName;
        case 'Value': return row.Value;
        case 'StartDate': return row.StartDate;
        case 'EndDate': return row.EndDate;
        default: return '';
      }
    };
  }

  ngOnInit(): void {
    if (!this.verify) {
      this.displayedColumns.push('delete');
    }

    this.shareClientId.tmpDataOptions$.subscribe((options) => {
      if (Object.keys(options).length !== 0 && !this.verify) {
        if (!this.shareClientId.tmpDataList.some((item) => item === options)) {
          this.shareClientId.tmpDataList.push(options);
        }
      }
      this.setDataSource();
    });
    this.setDataSource();
  }

  removeFromCurrentList(row: OptionViewRow) {
    const index = this.shareClientId.tmpDataList.findIndex(
      (item) => item.ID === row.ID && item.OptionTypeID === row.OptionTypeID
    );
    if (index !== -1) {
      this.shareClientId.tmpDataList.splice(index, 1);
      this.setDataSource();
      this.shareClientId.resetTmpData();
    }
  }

  private async setDataSource(): Promise<void> {
    await new Promise(r => setTimeout(r, 400));
    this.rawDataSource = [...this.shareClientId.tmpDataList];

    this.dataTypes = [];
    this.dataVersions = [];

    const promises = this.rawDataSource.map((data) => {
      return new Promise<void>((resolve) => {
        const optionVersion = this.dataService.getOptionVersionById(data.OptionVersionID as number);

        this.dataService.getOptionTypeByIDRest(data.OptionTypeID as number).subscribe((type) => {
          this.dataTypes.push(type ?? { Icon: '', Name: '', Description: '' } as any);
          if (optionVersion) {
            this.dataVersions.push(optionVersion);
          }

          data.StartDate = data.StartDate.startsWith('0001') ? '' : data.StartDate.split('T')[0];
          data.EndDate = data.EndDate.startsWith('0001') ? '' : data.EndDate.split('T')[0];

          resolve();
        });
      });
    });

    await Promise.all(promises);

    this.tableDataSource.data = this.rawDataSource.map((data, i) => ({
      ...data,
      optIcon: this.dataTypes[i]?.Icon ?? '',
      optProductID: this.dataTypes[i]?.ProductID ?? '',
      optName: this.dataTypes[i]?.Name ?? '',
      optDescription: this.dataTypes[i]?.Description ?? '',
      optUnit: this.dataTypes[i]?.Unit ?? '',
    }));
  }
}
